var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareer02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2818 28.5329H21.6603V0.512939H30.2818V28.5329ZM23.8157 26.3776H28.1264V2.66832H23.8157V26.3776ZM19.5049 28.5329H10.8834V9.13448H19.5049V28.5329ZM8.72798 28.5329H0.106445V15.6006H8.72798V28.5329Z",
    fill: "#FED700"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.795,
    y: 1.51294,
    width: 6.48682,
    height: 26.02,
    stroke: "#FED700",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer02);
export default __webpack_public_path__ + "static/media/career-02.c1cdb5d1f3d378c9f19d5ef472877540.svg";
export { ForwardRef as ReactComponent };